const INITIAL_VALUES = {
  consentCheck: false,
  candidates: [],
};

export default INITIAL_VALUES;
